import { useState, useEffect } from "react";
import { usePage } from "@inertiajs/react";

import TextField from "/components/TextField";
import { useToast } from "/utils/toast-context.jsx";

export default function SettingTextField({
  name,
  value: defaultValue,
  delay = 1000,
}) {
  const props = usePage().props;
  const { successToast, errorToast } = useToast();

  const [value, setValue] = useState(defaultValue);
  const [checkValue, setCheckValue] = useState(value);
  const [inProgress, setInProgress] = useState(false);

  const onChange = (newValue) => {
    if (newValue == checkValue || newValue.length < 1)
      return;

    const lastSaved = checkValue;

    setCheckValue(newValue);
    setInProgress(true);

    const failed = () => {
      // Restore the guard, or retyping the same value would be a no-op.
      setCheckValue(lastSaved);
      errorToast("Не удалось сохранить");
    };

    fetch(`/admin/settings/${name}`,{
      method: "PUT",
      body: JSON.stringify({ authenticity_token: props.csrf_token, value: newValue }),
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
    }).then(
      (response) => response.ok ? successToast("Сохранено") : failed(),
      failed,
    ).finally(() => setInProgress(false));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onChange(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, onChange, delay]);

  return (
    <TextField onChange={(newValue) => setValue(newValue)} value={value} disabled={inProgress} />
  );
}
